// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__p4YcE","validationTips":"StatementDescriptor_validationTips__2gu0U"};